import { render, staticRenderFns } from "./InstructionNew.vue?vue&type=template&id=7cdf6eec"
import script from "./InstructionNew.vue?vue&type=script&lang=js"
export * from "./InstructionNew.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports